import * as types from '../constants';

export const initialAppState = {
  titleText: 'Explore Indicator DNS Data',
  auxillaryText: null,
};

export default (state = initialAppState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.CHANGE_TITLE:
      return {
        ...state,
        titleText: payload.titleText,
        auxillaryText: payload.auxillaryText,
      };
    default:
      return state;
  }
};
